import { PLANS, PLAN_RANK, ROLES } from "../config/permissions.constants";

export function resolveFeatureAccess(feature, user) {
  const roles = Array.isArray(user?.role)
    ? user.role
    : [user?.role].filter(Boolean);

  const isPlayerOnly = roles.includes(ROLES.PLAYER) &&
    !roles.includes(ROLES.COACH) &&
    !roles.includes(ROLES.ADMIN);

  const userPlan = user?.plan || PLANS.FREE;

  // ----------------------------------
  // Role gate
  // ----------------------------------
  if (!feature.access.roles.some((r) => roles.includes(r))) {
    return { visible: false };
  }

  // ----------------------------------
  // PLAN gate (PLAYER-ONLY FEATURES ONLY)
  // ----------------------------------
  if (
    isPlayerOnly &&
    !feature.isCoachProvided &&
    feature.access.minPlan !== PLANS.FREE
  ) {
    if (PLAN_RANK[userPlan] < PLAN_RANK[feature.access.minPlan]) {
      return {
        visible: true,
        disabled: true,
        reason: "UPGRADE_REQUIRED",
      };
    }
  }

  // ----------------------------------
  // Coach required (player view)
  // ----------------------------------
  if (
    isPlayerOnly &&
    feature.isCoachProvided &&
    !user?.coachId
  ) {
    return {
      visible: false, // hide entire coach corner
    };
  }

  return { visible: true, disabled: false };
}
